(function () {
  'use strict';

  var STORAGE_KEY = 'inkmerge_saved_designs_v1';
  var STORAGE_LIMIT = 24;

  function readJson(element) {
    if (!element) return null;
    try { return JSON.parse(element.textContent || 'null'); }
    catch (error) { return null; }
  }

  function safeProductUrl(value) {
    try {
      var url = new URL(String(value || ''), window.location.origin);
      if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) return '';
      return url.pathname;
    } catch (error) { return ''; }
  }

  function safeImageUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(String(value), window.location.origin);
      var allowed = url.origin === window.location.origin || url.hostname === 'cdn.shopify.com';
      return allowed && url.protocol === 'https:' ? url.href : '';
    } catch (error) { return ''; }
  }

  function normalize(item) {
    if (!item || typeof item !== 'object') return null;
    var normalized = {
      id: String(item.id || ''),
      title: String(item.title || '').trim().slice(0, 160),
      url: safeProductUrl(item.url),
      image: safeImageUrl(item.image),
      alt: String(item.alt || item.title || '').trim().slice(0, 180)
    };
    return normalized.id && normalized.title && normalized.url ? normalized : null;
  }

  function readSaved() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.map(normalize).filter(Boolean).slice(0, STORAGE_LIMIT) : [];
    } catch (error) { return []; }
  }

  function writeSaved(items) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, STORAGE_LIMIT))); }
    catch (error) { /* Storage can be unavailable in restricted browsing contexts. */ }
  }

  function makeItem(item) {
    var article = document.createElement('article');
    article.className = 'imsave__item';
    article.setAttribute('role', 'listitem');

    var link = document.createElement('a');
    link.className = 'imsave__item-link';
    link.href = item.url;
    link.setAttribute('aria-label', 'View saved design ' + item.title);
    link.setAttribute('data-im-route', 'saved-design-product');

    var media = document.createElement('span');
    media.className = 'imsave__item-media';
    if (item.image) {
      var image = document.createElement('img');
      image.className = 'imsave__item-image';
      image.src = item.image;
      image.alt = item.alt;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    }

    var copy = document.createElement('span');
    copy.className = 'imsave__item-copy';
    var label = document.createElement('span');
    label.textContent = 'Saved on this device';
    var title = document.createElement('strong');
    title.textContent = item.title;
    copy.appendChild(label);
    copy.appendChild(title);

    link.appendChild(media);
    link.appendChild(copy);
    article.appendChild(link);
    return article;
  }

  function placeNearPurchase(root) {
    var scope = root.closest('[data-impdp]') || document;
    var form = scope.querySelector('form[action*="/cart/add"]') || scope.querySelector('form');
    if (!form) return;
    var anchor = form.closest('[data-impdp-form]') || form;
    if (anchor.nextElementSibling !== root) anchor.insertAdjacentElement('afterend', root);
  }

  function initialize(root) {
    var current = normalize(readJson(root.querySelector('[data-imsave-current]')));
    var toggle = root.querySelector('[data-imsave-toggle]');
    var label = root.querySelector('[data-imsave-label]');
    var details = root.querySelector('[data-imsave-details]');
    var count = root.querySelector('[data-imsave-count]');
    var list = root.querySelector('[data-imsave-list]');
    var clear = root.querySelector('[data-imsave-clear]');
    if (!current || !toggle || !label || !details || !count || !list || !clear) return;

    placeNearPurchase(root);
    root.hidden = false;

    function render() {
      var items = readSaved();
      var isSaved = items.some(function (item) { return item.id === current.id; });
      toggle.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      label.textContent = isSaved ? 'Saved on this browser' : 'Save this design';
      root.querySelector('.imsave__heart').textContent = isSaved ? '♥' : '♡';
      count.textContent = String(items.length);
      count.setAttribute('aria-label', items.length + (items.length === 1 ? ' saved design' : ' saved designs'));
      details.hidden = items.length === 0;
      if (!items.length) details.open = false;
      list.replaceChildren();
      items.forEach(function (item) { list.appendChild(makeItem(item)); });
    }

    toggle.addEventListener('click', function () {
      var items = readSaved();
      var exists = items.some(function (item) { return item.id === current.id; });
      items = exists
        ? items.filter(function (item) { return item.id !== current.id; })
        : [current].concat(items.filter(function (item) { return item.id !== current.id; }));
      writeSaved(items);
      render();
    });

    clear.addEventListener('click', function () {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
      render();
      toggle.focus();
    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) render();
    });

    render();
  }

  function initializePage(root) {
    var list = root.querySelector('[data-imsave-page-list]');
    var empty = root.querySelector('[data-imsave-page-empty]');
    var status = root.querySelector('[data-imsave-page-status]');
    var clear = root.querySelector('[data-imsave-page-clear]');
    if (!list || !empty || !status || !clear) return;

    function renderPage() {
      var items = readSaved();
      list.replaceChildren();
      items.forEach(function (item) { list.appendChild(makeItem(item)); });
      empty.hidden = items.length > 0;
      clear.hidden = items.length === 0;
      status.textContent = items.length
        ? items.length + (items.length === 1 ? ' saved design on this browser.' : ' saved designs on this browser.')
        : 'No designs are saved on this browser yet.';
    }

    clear.addEventListener('click', function () {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
      renderPage();
      status.focus();
    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) renderPage();
    });

    renderPage();
  }

  function start() {
    document.querySelectorAll('[data-im-saved-designs]').forEach(initialize);
    document.querySelectorAll('[data-imsave-page]').forEach(initializePage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
